/**
 * spinner.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, Input } from "@angular/core";
// import { Observable } from "rxjs/Rx";

export type Spinner = "ellipsis";

/**
 * A {@link SpinnerComponent} displays a loading indicator or "spinner".
 */
@Component({
  selector: "spinner",
  template: `
    <div *ngIf="type === 'ellipsis'" class="loader ellipsis">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  `
})
export class SpinnerComponent
{
  @Input()
  public type : Spinner = "ellipsis";
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/spinner.component.ts